import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./translations/en.json";
import zh_Hans from "./translations/zh-Hans.json";
import zh_Hant from "./translations/zh-Hant.json";

// 创建 i18n 实例
const i18nextInstance = i18next.createInstance();
// 注入插件，initReactI18next 是一个 3rdParty 类型的插件，也就是把实例给第三方插件，让其完全可以获取 i18n 实例所有信息
i18nextInstance.use(initReactI18next);

// 所有翻译资源
const resources = {
    en: { translation: en },
    zh: { translation: zh_Hans },
    zh_Hant: { translation: zh_Hant },
};

// i18n 实例初始化内容
i18nextInstance.init(
    {
        lng: "en",
        // 后备语言，如果用户语言的翻译不可用时使用此顺序
        fallbackLng: ["en", "zh_Hant"],
        // 如果需要调试可以打开
        // debug: process.env.NODE_ENV === "development",
        ns: ["translation"],
        // 默认值就是 translation，可以进行设置
        defaultNS: "translation",
        resources: resources,
        // appendNamespaceToMissingKey: false,
        // 资源加载器，可以自定义资源加载器
        // backend: {
        //     loadPath: 'https://cdn.example.com/locales/{{lng}}/{{ns}}.json'
        // },
        // 自定义加载器，可以实现自定义的资源加载逻辑
        // load: (language, namespace, callback) => {
        //     // 自定义加载逻辑
        //     callback(null, resources[language][namespace])
        // },
        // 自定义资源缓存时间，默认是 60000ms
        // cache: {
        //     maxAge: 60000
        // },
    },
    (err) => {
        if (err) return console.log("something went wrong loading", err);
    }
);

export default i18nextInstance;
